import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { useCart } from '../../CartContext';
import { supabase } from '../../lib/supabaseClient.ts';



function ShopAreaCat() {
  const [categories, setCategories] = useState([]);
   const [products, setProducts] = useState([]);
   const [selectedCategory, setSelectedCategory] = useState("");
   const [selectedSubcategory, setSelectedSubcategory] = useState("");
 const navigate = useNavigate();

   // Fetch categories and products for 'cat'
   useEffect(() => {
  const fetchCategories = async () => {
  const { data, error } = await supabase
    .from("categories")
    .select("*")
    .eq("pet_type", "cat")
.order("order", { ascending: true })

  if (error) {
    console.error("Error fetching categories:", error);
  } else {
    setCategories(data);
    if (data.length > 0) {
      setSelectedCategory(data[0].name); // Default category
    }
  }
};

 
     const fetchProducts = async () => {
 const { data, error } = await supabase
   .from("products")
   .select("id, name, image, price_range, description, category, subcategory");
 
       if (error) {
         console.error("Error fetching products:", error);
       } else {
         setProducts(data);
       }
     };
 
     fetchCategories();
     fetchProducts();
   }, []);
 
   const selectedCategoryObj = categories.find((cat) => cat.name === selectedCategory);
   const subcategories = selectedCategoryObj?.subcategories || [];
 
   const filteredProducts = products.filter((product) => {
     const matchCategory = product.category === selectedCategory;
     const matchSubcategory = selectedSubcategory
       ? product.subcategory === selectedSubcategory
       : true;
     return matchCategory && matchSubcategory;
   });
 
const normalize = (str) =>
  str?.trim().toLowerCase();

  return (
    <div className="shop-area pt-110 pb-110">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="shop-wrap">
              <h4 className="title mb-4">Categories</h4>

              {/* Category Cards */}
              <div className="row mb-4">
                {categories.map(cat => {

const productCount = products.filter(
  p => normalize(p.category) === normalize(cat.name)
).length;              
    console.log("count",productCount)
                  const isSelected = selectedCategory === cat.name;
console.log("Product category values:", products.map(p => p.category));
console.log("Category name:", cat.name);
                  return (
                    <div key={cat.name} className="col-lg-3 col-md-4 col-sm-6 mb-3">
                      <button
                   onClick={() => {
  // navigate(`/products?category=${encodeURIComponent(cat.name)}`);
      navigate(`/category/${cat.id}/${encodeURIComponent(cat.name)}`);

}}

                        style={{
                              width: "100%",
                          height: "230px",
                          backgroundColor: isSelected ? "#fff" : "#fff",
                          color: isSelected ? "#333" : "#333",
                          border: isSelected ? "2px solid #000" : "1px solid #ddd",
                          borderRadius: "12px",
                          overflow: "hidden",
                          padding: 0,
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "15px",
                          transition: "all 0.3s ease",
                          boxShadow: isSelected ? "0 4px 10px rgba(0,0,0,0.2)" : "0 2px 6px rgba(0,0,0,0.06)",
                        }}
                      >
                        <div style={{ height: "100px", overflow: "hidden" }}>
                                          <img
  src={cat.image}
  alt={cat.name}
  style={{
    width: "40%",
    height: "90%",
    objectFit: "cover",
    marginLeft: window.innerWidth <= 768 ? "200px" : "0px", // shift on mobile
  }}
/>
                        </div>
                        <div style={{ padding: "8px" }}>
                          {cat.name}
                          <div style={{ fontSize: "13px", fontWeight: "normal" }}>
                            {productCount} produit{productCount > 1 ? "s" : ""}
                          </div>
                        </div>
                      </button>
                    </div>
                  );
                })}
              </div>

              {/* Subcategory Filter */}
              {subcategories.length > 0 && (
                <div
                  className="subcategory-filter d-flex flex-wrap gap-3 mb-4"
                  style={{ justifyContent: "flex-start" }}
                >
                  {subcategories.map((sub) => (
                    <button
                      key={sub}
                      onClick={() => setSelectedSubcategory(sub)}
                      style={{
                        borderRadius: "16px",
                        padding: "10px 20px",
                        fontSize: "15px",
                        fontWeight: "500",
                        border: selectedSubcategory === sub ? "2px solid #c71585" : "1px solid #ccc",
                        backgroundColor: selectedSubcategory === sub ? "#fce5ef" : "#f9f9f9",
                        color: selectedSubcategory === sub ? "#c71585" : "#333",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                        marginRight: "12px",     // <-- added spacing
                        marginBottom: "12px",    // <-- spacing between rows
                      }}
                    >
                      {sub}
                    </button>
                  ))}
                  <button
                    onClick={() => setSelectedSubcategory("")}
                    style={{
                      borderRadius: "16px",
                      padding: "10px 20px",
                      fontSize: "15px",
                      fontWeight: "500",
                      border: selectedSubcategory === "" ? "2px solid #c71585" : "1px solid #ccc",
                      backgroundColor: selectedSubcategory === "" ? "#fce5ef" : "#f9f9f9",
                      color: selectedSubcategory === "" ? "#c71585" : "#333",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      marginRight: "12px",     // <-- added spacing
                      marginBottom: "12px",
                    }}

                  >
                    Tous
                  </button>
                </div>
              )}


              {/* Product Count */}
              <div className="shop-page-meta mb-30">
                <div className="shop-showing-result">
                  <p>Total Produits {filteredProducts.length}</p>
                </div>
              </div>

              {/* Products Grid */}
              {selectedCategory && selectedCategory.subcategories?.length > 0 ? (
  // Show subcategories if they exist
  <div className="row justify-content-center">
    {selectedCategory.subcategories.map((sub) => (
      <div key={sub.id} className="col-lg-3 col-md-4 col-sm-6 mb-3">
        <button
          className="btn btn-outline-primary w-100"
          onClick={() =>
            navigate(`/category/${sub.id}/${encodeURIComponent(sub.name)}`)
          }
        >
          {sub.name}
        </button>
      </div>
    ))}
  </div>
) : (
  // Show products if no subcategories
  <div className="row justify-content-center">
    {filteredProducts.length > 0 ? (
      filteredProducts.slice(0, 20).map((product) => (
        <div key={product.id} className="col-lg-3 col-md-4 col-sm-6 mb-4">
          <div
            className="shop-item"
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              padding: "16px",
              transition: "transform 0.3s ease, boxShadow 0.3s ease",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div
              className="shop-thumb position-relative"
              style={{
                height: "220px",
                overflow: "hidden",
                borderRadius: "8px",
                marginBottom: "1rem",
              }}
            >
              {product.promo && (
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    backgroundColor: "green",
                    color: "#fff",
                    padding: "4px 8px",
                    borderRadius: "12px",
                    fontSize: "12px",
                    fontWeight: "600",
                    zIndex: 10,
                  }}
                >
                  Promo
                </div>
              )}

              <Link to={`/shop-details/${product.id}`}>
                <img
                  src={product.image}
                  alt={product.name}
                  style={{
                    width: "50%",
                    height: "90%",
                    objectFit: "cover",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              </Link>
            </div>
            <div className="shop-content">
              <h5
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  marginBottom: "8px",
                }}
              >
                <Link
                  to={`/shop-details/${product.id}`}
                  style={{ color: "#333", textDecoration: "none" }}
                >
                  {product.name}
                </Link>
              </h5>
              <div
                className="shop-content-bottom"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span
                  className="price"
                  style={{ fontWeight: "bold", color: "#c71585" }}
                >
                  {product.priceRange}
                </span>
                <span className="add-cart"></span>
              </div>
            </div>
          </div>
        </div>
      ))
    ) : (
      <div className="col-12 text-center mt-4">
        <p className="fs-5">
          🐾{" "}
          {categories.find((c) => c.name === selectedCategory?.name)
            ?.emptyMessage || "Aucun produit trouvé."}
        </p>
      </div>
    )}
  </div>
)}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


export default ShopAreaCat;
